import { useEffect } from 'react';

const ensureMeta = (name) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  return el;
};

const ensureCanonical = () => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  return el;
};

const SeoHead = ({ title, description, canonicalPath = '', faqSchema = null }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) ensureMeta('description').setAttribute('content', description);
    ensureCanonical().setAttribute('href', `https://ubuntueventsmanagement.co.za${canonicalPath}`);

    let scriptEl = null;
    if (faqSchema?.length) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.text = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqSchema.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.a,
          },
        })),
      });
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl) {
        document.head.removeChild(scriptEl);
      }
    };
  }, [title, description, canonicalPath, faqSchema]);

  return null;
};

export default SeoHead;
